var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2427 3.75733L9.88533 6.11467M12.2427 3.75733C11.1174 2.63212 9.5913 2 8 2C6.4087 2 4.88255 2.63212 3.75733 3.75733M12.2427 3.75733C13.3679 4.88255 14 6.4087 14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2427 12.2427M9.88533 6.11467C9.38524 5.61457 8.70724 5.33333 8 5.33333C7.29276 5.33333 6.61476 5.61457 6.11467 6.11467M9.88533 6.11467C10.3854 6.61476 10.6667 7.29276 10.6667 8C10.6667 8.70724 10.3854 9.38524 9.88533 9.88533M9.88533 9.88533L12.2427 12.2427M9.88533 9.88533C9.38524 10.3854 8.70724 10.6667 8 10.6667C7.29276 10.6667 6.61476 10.3854 6.11467 9.88533M12.2427 12.2427C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31449 12.7998 3.75733 12.2427M6.11467 6.11467L3.75733 3.75733M6.11467 6.11467C5.61457 6.61476 5.33333 7.29276 5.33333 8C5.33333 8.70724 5.61457 9.38524 6.11467 9.88533M3.75733 3.75733C2.63212 4.88255 2 6.4087 2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20018 11.6855 3.75733 12.2427M6.11467 9.88533L3.75733 12.2427",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportOutline);
export default __webpack_public_path__ + "static/media/SupportOutline.78179e69f7a6f46ae504c8882f3ad094.svg";
export { ForwardRef as ReactComponent };